

// 1. CREATE API TYPES
export const CREATE_CARE_AND_USE_REQUEST = "CREATE_CARE_AND_USE_REQUEST";
export const CREATE_CARE_AND_USE_SUCCESS = "CREATE_CARE_AND_USE_SUCCESS";
export const CREATE_CARE_AND_USE_FAILURE = "CREATE_CARE_AND_USE_FAILURE";

// 2. GET ALL API TYPES
export const GET_ALL_CARE_AND_USE_REQUEST = "GET_ALL_CARE_AND_USE_REQUEST";
export const GET_ALL_CARE_AND_USE_SUCCESS = "GET_ALL_CARE_AND_USE_SUCCESS";
export const GET_ALL_CARE_AND_USE_FAILURE = "GET_ALL_CARE_AND_USE_FAILURE";

// 3. GET ONE API TYPES
export const GET_ONE_CARE_AND_USE_REQUEST = "GET_ONE_CARE_AND_USE_REQUEST";
export const GET_ONE_CARE_AND_USE_SUCCESS = "GET_ONE_CARE_AND_USE_SUCCESS";
export const GET_ONE_CARE_AND_USE_FAILURE = "GET_ONE_CARE_AND_USE_FAILURE";

// 4. EDIT/UPDATE API TYPES
export const EDIT_CARE_AND_USE_REQUEST = "EDIT_CARE_AND_USE_REQUEST";
export const EDIT_CARE_AND_USE_SUCCESS = "EDIT_CARE_AND_USE_SUCCESS";
export const EDIT_CARE_AND_USE_FAILURE = "EDIT_CARE_AND_USE_FAILURE";

// 5. DELETE API TYPES
export const DELETE_CARE_AND_USE_REQUEST = "DELETE_CARE_AND_USE_REQUEST";
export const DELETE_CARE_AND_USE_SUCCESS = "DELETE_CARE_AND_USE_SUCCESS";
export const DELETE_CARE_AND_USE_FAILURE = "DELETE_CARE_AND_USE_FAILURE";

export const UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_REQUEST = "UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_REQUEST";
export const UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_SUCCESS = "UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_SUCCESS";
export const UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_FAILURE = "UPLOADCSV_CARE_AND_USE_INSTRUCTIONS_FAILURE";